import { queryOptions } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import { obtenerMisAsignaciones, obtenerMiPerfil } from "../services/perfil.api";

/**
 * queryOptions compartidos entre el `loader` de la ruta `/perfil` y los
 * componentes que consumen estos datos (patrón del repo · evita el doble
 * fetch y el render "en blanco" mientras la primera consulta viaja).
 *
 * `staleTime` generoso: perfil y asignaciones casi nunca cambian dentro de
 * una sesión, así que tras la precarga del loader la caché sirve el dato al
 * instante en visitas siguientes. (El estado del 2FA tiene su propio
 * queryOptions en la feature `seguridad`.)
 */
export const miPerfilQueryOptions = queryOptions({
  queryKey: qk.miPerfil,
  queryFn: obtenerMiPerfil,
  staleTime: 5 * 60_000,
});

export const misAsignacionesQueryOptions = queryOptions({
  queryKey: qk.misAsignaciones,
  queryFn: obtenerMisAsignaciones,
  staleTime: 5 * 60_000,
});
